import React from 'react';
import getCountryName from '../lib/util/get-country-name';

const legalUrl = 'http://homepage.aiminspections.com/site-and-service-terms-and-conditions/';

export default ({
	EN: {
		continueButton: 'Continue',
		backButton: 'Back',
		inputs: {
			phone: {
				label: 'Phone',
				placeholder: '(###) ### - ####'
			},
			email: {
				label: 'Email',
				placeholder: 'yourname@example.com'
			}
		},
		validation: {
			fieldIsRequired: 'This field is required',
			enterValidZip: 'Enter a valid zip code',
			enterValidEmail: 'Enter a valid email address',
			enterValidVin: 'Enter a valid VIN',
			enterValidAccountNo: 'Enter a valid account number',
			enterValidPhone: 'Enter a valid phone number. 0 nor 1 can not be the first digit. example: (222)-333-4444',
			selectPrefContactMethod: 'You must select a preferred contact method'
		},
		formatting: {
			vehicleYmm: vehicle => ['year', 'make', 'model'].map(f => vehicle[f]).filter(f => !!f).join(' '),
			vehicleVin: vehicle => `VIN: ${vehicle.vin}`,
			location: l => `${l.street1}${l.street2 ? ' ' + l.street2 : ''}, ${l.city}, ${l.state} ${l.zip} ${getCountryName(l.country)}`
		},
		callCenterPhone: '(866) 621-9123',
		callCenterEmail: 'mmi.customersupport@coxautoinc.com',
		callCenterHours: 'M-F: 7:00 AM - 8:30 PM (Eastern Time)',
		smsLegal: () => (<p>By selecting SMS text method, you certify that: You are the subscriber, or have the subscriber&#39;s permission, and agree to Manheim Mobile Inspections&#39; <a href={legalUrl} target='_blank' rel='noopener noreferrer'>Terms and Conditions</a> and <a href={legalUrl} target='_blank' rel='noopener noreferrer'>Privacy Policy</a>. Standard text messaging and data charges may apply. You may opt out of mobile text alerts at any time.</p>),
		titleStem: 'Self Schedule'
	},
	ES: {
		inputs: {
			phone: {
				label: 'Phone',
				placeholder: '(###) ### - ####'
			},
			email: {
				label: 'Email',
				placeholder: 'yourname@example.com'
			}
		},
		continueButton: 'Continue',
		backButton: 'Back',
		validation: {
			fieldIsRequired: 'Este campo es requerido',
			enterValidZip: 'Ingrese un código postal válido',
			enterValidEmail: 'Introduzca una dirección de correo electrónico válida',
			enterValidVin: 'Enviar un VUN válido',
			enterValidAccountNo: 'Enviar un número de cuenta válido',
			enterValidPhone: 'Introduzca un número de teléfono válido. Los numeros 0 y 1 no pueden ser el primer dígito. ejemplo (222)-333-4444',
			selectPrefContactMethod: 'Debe seleccionar un método de contacto preferido'
		},
		formatting: {
			vehicleYmm: vehicle => ['year', 'make', 'model'].map(f => vehicle[f]).filter(f => !!f).join(' '),
			vehicleVin: vehicle => `VIN: ${vehicle.vin}`,
			location: l => `${l.street1}${l.street2 ? ' ' + l.street2 : ''}, ${l.city}, ${l.state} ${l.zip} ${getCountryName(l.country)}`
		},
		callCenterPhone: '(866) 621-9123',
		callCenterEmail: 'mmi.customersupport@coxautoinc.com',
		callCenterHours: 'M-F: 7:00 AM - 8:30 PM (Eastern Time)',
		smsLegal: () => (<p>Al seleccionar el método de texto SMS, usted certifica que: Usted es el suscriptor o tiene el permiso del suscriptor, y acepta los <a href={legalUrl} target='_blank' rel='noopener noreferrer'>Términos y condiciones</a> de Manheim Mobile Inspections y <a href={legalUrl} target='_blank' rel='noopener noreferrer'>Política de privacidad</a>. Se pueden aplicar cargos estándar de mensajería de texto y datos. Puedes inhabilitar las alertas de texto móvil en cualquier momento.</p>),
		titleStem: 'Programación Propia'
	}
});
